<template>
<!-- A general UI to display messages to users -->
<div v-show="showGuanzoMessage" class="guanzo-message">
    <div v-if="showOAuthMessage">
        <div v-if="isBroadcaster">
            <div v-if="oauthState !== $const.OAUTH_SUCCESS">
                <div class="m-b-5">
                    {{ $t('broadcasterOAuthWarning') }}
                </div>
                <OAuthButton :oauthState.sync="oauthState"/>
            </div>
        </div>
        <div v-else>{{ $t('viewerOAuthWarning') }}</div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

import OAuthButton from '@/components/OAuthButton'

export default {
    name: 'GuanzoMessage',
    data: () => ({
        oauthState: null,
    }),
    computed: {
        ...mapGetters([
            'isLoadingChannel',
            'isBroadcaster',
            'isPageViewer',
            'requiresOAuthSetup'
        ]),
        // In case streamer rarely checks config page, show oauth msg on viewer.
        // Don't show if on config page, there's already a prompt there.
        showOAuthMessage: vm => vm.requiresOAuthSetup && vm.isPageViewer,
        showGuanzoMessage: vm => vm.showOAuthMessage && !vm.isLoadingChannel
    },
    components: {
        OAuthButton,
    },
}
</script>

<style lang="scss">
$img-size: 30px;

.guanzo-message {
    display: flex;
    align-items: center;
    text-align: center;
    padding: 8px;
    font-size: 0.8rem;
    border-bottom: 1px solid $border-color;
    .profile-img {
        flex: 0 0 $img-size;
        width: $img-size;
        height: $img-size;
        margin-right: 10px;
    }
}
</style>
